<template>
  <div class="projectDetail">
    <component
      :is="dialogType"
      :width="size"
      :size="size"
      :title="title"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
    >
      <!-- <basic-container> -->
      <avue-form
        :option="option"
        ref="componentForm"
        v-model="form"
        @resetForm="resetForm"
        @submit="submit"
      >
        <template
          #[slotName]="slotProps"
          v-for="(slot, slotName) in $scopedSlots"
        >
          <slot :name="slotName" v-bind="slotProps" />
        </template>
        <template slot="menuForm">
          <div class="btns">
            <el-button v-if="showCancel" @click="cancelModal">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
         
        </template>
      </avue-form>
      <!-- </basic-container> -->
    </component>
  </div>
</template>

<script>
export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    showCancel: {
      type: Boolean,
      default: false,
    },
    detailForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
    option: {
      type: Object,
      default: () => {
        return {};
      },
    },
    title: {
      type: String,
      default: "详情",
    },
    size: {
      type: String,
      default: "70%",
    },
    dialogType: {
      type: String,
      default: "elDialog",
    },
  },
  data() {
    return {
      form: {},
    };
  },
  created() {},
  watch: {
    detailForm: {
      handler() {
        this.form = Object.assign({}, this.form, this.detailForm);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted: function () {
    this.form = this.detailForm;
  },
  methods: {
    cancelModal() {
      this.$emit("update:visible", false);
    },
    submit() {
      this.$refs.componentForm.validate((valid, done,msg) => {
          if (valid) {
            this.$emit("submit", this.form, done);
          } else {
            console.log('error submit!!');
            return false;
          }
        })
    },
    resetForm(form, done) {
      this.$emit("resetForm");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer__header {
  margin-bottom: 20px;
}
/deep/ .avue-upload .el-icon-plus {
  display: none;
}
/deep/ .avue-upload--list .el-upload {
  border: none;
  .avue-upload__avatar {
    width: 100px;
    height: 100px;
  }
}
/deep/ .el-dialog__body {
  padding-top: 0;
  padding-bottom: 0;
}
/deep/.el-collapse-item__wrap .avue-form__group--flex {
  background: #fff !important;
}
/deep/.el-dialog__header {
  border-bottom: 1px solid #ededf0;
}
/deep/.el-dialog__body {
  padding-left: 0;
}
/deep/.avue-upload .el-icon-plus {
  display: inline-block;
}
/deep/.el-upload--picture-card {
  width: 202px;
  height: 126px;
  background: #F5F7FA;
  border-color: #dcdee0;
}
/deep/.el-upload__tip {
  font-weight: 400;
  font-size: 14px;
  color: #939399;
  margin-top: 0;
}
.btns{
  display: flex;
  justify-content: flex-end
}
/deep/.el-upload-list--picture-card .el-upload-list__item{
  width: 202px;
  height: 126px;
  border: none;
}
</style>
